<template>
<div @click="emit" class="columns">
  <slot/>
</div>  
</template>
<script>
export default {
  methods: {
    emit() {
      this.$emit('click')
    }
  }
}
</script>